import { SvgIcon, SvgIconProps } from '@mui/material'

export function RemoteControlIcon(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.33329 1.83334C4.24125 1.83334 4.16663 1.90796 4.16663 2.00001V14C4.16663 14.0921 4.24125 14.1667 4.33329 14.1667H11.6666C11.7587 14.1667 11.8333 14.0921 11.8333 14V2.00001C11.8333 1.90796 11.7587 1.83334 11.6666 1.83334H4.33329ZM3.16663 2.00001C3.16663 1.35568 3.68896 0.833344 4.33329 0.833344H11.6666C12.311 0.833344 12.8333 1.35568 12.8333 2.00001V14C12.8333 14.6443 12.311 15.1667 11.6666 15.1667H4.33329C3.68896 15.1667 3.16663 14.6443 3.16663 14V2.00001Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99996 10.5C7.53972 10.5 7.16663 10.8731 7.16663 11.3333C7.16663 11.7936 7.53972 12.1667 7.99996 12.1667C8.4602 12.1667 8.83329 11.7936 8.83329 11.3333C8.83329 10.8731 8.4602 10.5 7.99996 10.5ZM6.16663 11.3333C6.16663 10.3208 6.98744 9.5 7.99996 9.5C9.01248 9.5 9.83329 10.3208 9.83329 11.3333C9.83329 12.3459 9.01248 13.1667 7.99996 13.1667C6.98744 13.1667 6.16663 12.3459 6.16663 11.3333Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 3.33334C5.5 3.0572 5.72386 2.83334 6 2.83334H10C10.2761 2.83334 10.5 3.0572 10.5 3.33334V6.00001C10.5 6.27615 10.2761 6.50001 10 6.50001H6C5.72386 6.50001 5.5 6.27615 5.5 6.00001V3.33334ZM6.5 3.83334V5.50001H9.5V3.83334H6.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.16663 8C7.16663 7.72386 7.39048 7.5 7.66663 7.5H8.33329C8.60943 7.5 8.83329 7.72386 8.83329 8C8.83329 8.27614 8.60943 8.5 8.33329 8.5H7.66663C7.39048 8.5 7.16663 8.27614 7.16663 8Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default RemoteControlIcon
